export interface IGetAccountRouteHandler {
  name: string;
  // undefined until the active account is known (e.g. right after login)
  params: { accountId?: number } & Record<string, any>;
  query: Record<string, any>;
}

const getAccountRouteHandler = ({ name, params = {}, query = {}, activeAccountId }: {
  name: string;
  params?: Record<string, any>;
  query?: Record<string, any>;
  activeAccountId?: number;
}): IGetAccountRouteHandler => {
  // Router 4 throws on a missing required param, so a not-yet-loaded id renders as 0
  if ('id' in params && (params.id === undefined || params.id === null)) {
    params.id = 0;
  }

  const routeParams = {
    accountId: activeAccountId,
    ...params
  };

  return { name, params: { ...routeParams }, query: { ...query } };
}

export { getAccountRouteHandler };
